
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-label',
    label: '報名課程',
    model: 'course_name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '姓名',
    model: 'user_name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '身分證字號',
    model: 'user_twid',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: 'Email',
    model: 'email',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '病歷號',
    model: 'user_patient_no',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '床號',
    model: 'room_number',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '手機號碼',
    model: 'user_phone',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-toggle',
    label: '是否與爸爸一起參加',
    model: 'is_with_dad',
    required: true,
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '爸爸姓名',
    model: 'dad_name',
    visible: (model) => model.is_with_dad,
  },
  {
    type: 'bsx-label',
    label: '報名狀況',
    model: 'booking_status_label',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '報到狀況',
    model: 'checkin_status_label',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '後台取消管理員',
    model: 'cancel_admin_name',
    fieldClasses: 'bold',
    visible: (model) => model && model.booking_status == 'BSX_CANCEL',
  },
  {
    type: 'bsx-label',
    label: '報名時間',
    model: 'booking_time',
    fieldClasses: 'bold',
  },
  {
    type: "x-buttonCancelCourseBookingField",
    visible: (model) => model && model.booking_status == 'SIGN_UP',
  },
  {
    type: 'bsx-label',
    label: '取消預約時間',
    model: 'cancel_booking_time',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-toggle',
    label: '是否已報到',
    model: 'checkin_status',
    required: true,
  },
  {
    type: "bsx-dateTimePicker",
    label: "報到時間",
    model: "checkin_time",
    placeholder: "請選擇日期",
    hideClockIcon: true,
  },
  {
    type: 'bsx-toggle',
    label: '是否需處理',
    model: 'handle_status',
    required: true,
  },
  {
    type: "bsx-dateTimePicker",
    label: "處理時間",
    model: "checkin_time",
    placeholder: "請選擇日期",
    hideClockIcon: true,
  },
  {
    type: "bsx-dateTimePicker",
    label: "匯入日期",
    model: "import_time",
    placeholder: "請選擇日期",
    hideClockIcon: true,
  }
];

export default fields;
